$(function(){
    var owl = $('.product-images.owl-carousel').owlCarousel({
        loop: true,
        nav: true,
        dots: false,
        autoplay: false,
        items: 2,
    })

    setTimeout(function(){
        $('.product-images iframe').each(function(){
            var src = $(this).attr('src');
            console.log(src);
            $(this).attr('src', src + "enablejsapi=1");
        })
    }, 2000);

    owl.on('changed.owl.carousel', function(event) {
        console.log('changed');
        $('.product-video iframe').each(function(){
            this.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*')
        });
    })
})

$(window).on("load", function () {
    $(".photo-zoom").parent().zoom();
});
